import { every } from "lodash";
import { derived } from "svelte/store";
import {
  dateFieldValidator,
  emailFieldValidator,
  futureDateFieldValidator,
  phoneNumberFieldValidator,
  requiredArrayFieldValidator,
  requiredFieldValidator,
} from "../common/validation/validators";
import { currentUser, userStore } from "./users";

export const usersValidation = derived(currentUser, ($currentUser) => ({
  initialResult: requiredFieldValidator(true, $currentUser.initial),
  lastNameResult: requiredFieldValidator(true, $currentUser.lastName),
  emailResult: emailFieldValidator(true, $currentUser.email),
  phoneNumberResult: phoneNumberFieldValidator(
    $currentUser.secondFactor === "SMS",
    $currentUser.phoneNumber
  ),
  birthDateResult: dateFieldValidator(true, $currentUser.birthDate),
  ehLevelResult: requiredFieldValidator(true, $currentUser.ehLevel),
  idTypeResult: requiredFieldValidator(true, $currentUser.idType),
  secondFactorResult: requiredFieldValidator(true, $currentUser.secondFactor),
  documentNumberResult: requiredFieldValidator(
    true,
    $currentUser.documentNumber
  ),
  documentExpiryDateResult: futureDateFieldValidator(
    true,
    $currentUser.documentExpiryDate
  ),
  idCountryResult: requiredFieldValidator(true, $currentUser.idCountry),
  organizationsResult: requiredArrayFieldValidator(
    !$currentUser.allOrganizations,
    $currentUser.organizations
  ),
}));

export const usersPageState = derived(userStore, (users) => users.length > 0);

export const usersSaveState = derived(usersValidation, (validations) =>
  every(validations, "valid")
);
